/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react'
import { useCallback, useReducer } from 'react'
import { useLocation } from 'react-router-dom'

import PropTypes from 'prop-types'

import UTMContext from './Context'

// Local Definitions

const parameters = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'gclid',
  'fbclid',
]

const parametersAssignment = {
  utm_source  :'utmSource',
  utm_medium  :'utmMedium',
  utm_campaign:'utmCampaign',
  utm_term    :'utmTerm',
  utm_content :'utmContent',
  gclid       :'gclid',
  fbclid      :'fbclid',
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_STATE':
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}

/**
 * This is the component description.
 */
const UTMTracker = ({
  children,
  initialState,
  parameters: parametersList,
}) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  const { search } = useLocation()

  const updateState = useCallback(
    (payload) => {
      dispatch({
        type:'UPDATE_STATE',
        payload,
      })
    },
    [dispatch],
  )

  const registerUTMSearchParameters = useCallback(
    () => {
      const urlParams = new URLSearchParams(search)

      const utmData = parametersList.reduce((a, parameterName) => {
        if (urlParams.has(parameterName)) {
          // eslint-disable-next-line no-param-reassign
          a[parametersAssignment[parameterName]] = urlParams.get(parameterName)
        }
        return a
      }, {})

      updateState(utmData)
    },

    [search, updateState, parametersList],
  )

  return (
    <UTMContext.Provider
      value={{
        state,
        dispatch,
        updateState,
        registerUTMSearchParameters,
      }}
    >
      {children}
    </UTMContext.Provider>
  )
}

UTMTracker.propTypes = {
  /**
   * utmParams context initial state
   */
  initialState:PropTypes.objectOf(PropTypes.string),

  /**
   *  The children JSX
   */
  children:PropTypes.node,

  /**
   *  The list of parameters to track
   */
  parameters:PropTypes.arrayOf(PropTypes.string),
}

UTMTracker.defaultProps = {
  parameters,
}

export default UTMTracker
